import { environment } from 'src/environments/environment';
console.log('IS PROD =', environment.production);
const isProd = environment.production;

export const ConstantsService = {
  api: {
    frontEnd: isProd
      ? 'https://p30nailnew.izisoft.io/v1'
      : 'https://p30nailnew.izisoft.io/v1',
    frontEndV2: isProd
      ? 'https://p30nailnew.izisoft.io/v2'
      : 'https://p30nailnew.izisoft.io/v2',
  },

  // api:{
  //   frontEnd: 'http://192.168.11.35:4031/v1',
  //   frontEndV2: 'http://192.168.11.35:4031/v2',
  // },

  idAdminGeneral: '641ab6563d6bcb16db9750cc',
  emailAdminTotal: 'admin@gmail.com',
};
